import React from 'react';
import KnownSurfaceCalculator from './KnownSurfaceCalculator.js';
import UnknownSurfaceCalculator from './UnknownSurfaceCalculator.js';

let classNames = require("classnames");

class RaiseTheGarden extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            selectedOption: null
        };

        this.handleKnownChange = this.handleKnownChange.bind(this);
    }

    handleKnownChange(changeEvent) {
        this.setState({
            selectedOption: changeEvent.target.value
        });
    }

    render (){
        let calculatorForm = '';
        let selectedOption = this.state.selectedOption;
        if (selectedOption == 'Ja, ik weet hoeveel m2'){
            calculatorForm = <KnownSurfaceCalculator />;
        } else if(selectedOption == 'Nee, reken voor mij uit'){
            calculatorForm = <UnknownSurfaceCalculator />
        }
        let sizes = [
            'Ja, ik weet hoeveel m2',
            'Nee, reken voor mij uit'
        ];

        return <div>
            <div className="radio-buttons">
                <p>Weet u de oppervlakte die u wilt ophogen (in vierkante meters)?</p>
                {sizes.map((name) => {
                    let className = name.replace(' ', '-').toLowerCase();
                    return <label htmlFor={name} key={name} className={classNames({
                        className : true,
                        "active": this.state.selectedOption === name
                    })}>
                        <span>{name}</span>
                        <input
                            type="radio"
                            name="surfaceKnown"
                            id={name}
                            value={name}
                            checked={this.state.selectedOption === name}
                            onChange={this.handleKnownChange} />
                    </label>
                })}
            </div>
            <div className="formblock">
                {calculatorForm}
            </div>
        </div>
    }
}

export default RaiseTheGarden;